import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mt-3 mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " File ", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "menu-item px-3" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" }
const _hoisted_8 = { class: "fw-bold text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "text-gray-800 text-hover-primary"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-muted me-2 fs-7" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" by ")
const _hoisted_13 = { class: "fw-bolder" }
const _hoisted_14 = {
  key: 0,
  class: "symbol symbol-circle symbol-25px",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: ""
}
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuickAction = _resolveComponent("QuickAction")!
  const _component_DateTimeFormat = _resolveComponent("DateTimeFormat")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BaseForm = _resolveComponent("BaseForm")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_QuickAction, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "menu-link px-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args)))
                }, " Add File")
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (doc) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: doc.id
              }, [
                _createElementVNode("td", null, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(doc.name), 1),
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_DateTimeFormat, {
                      date: doc.dateCreated,
                      clazz: `fw-bolder`,
                      time: true
                    }, null, 8, ["date"]),
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(doc?.createdBy?.fullName), 1),
                    (doc.createdBy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_Avatar, {
                            avatar: doc?.createdBy?.avatar,
                            "user-id": doc.createdBy.id
                          }, null, 8, ["avatar", "user-id"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(_component_QuickAction, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        (doc.body)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "javascript:void(0);",
                              class: "menu-link px-3",
                              onClick: ($event: any) => (_ctx.onDownload(doc.id))
                            }, "Download", 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "menu-link px-3 text-danger",
                          onClick: ($event: any) => (_ctx.onDelete(doc.id))
                        }, "Delete", 8, _hoisted_18)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Panel, {
      name: `Add File`,
      show: _ctx.state.show,
      onClose: _ctx.onClosePanel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseForm, {
          onFormDiscard: _ctx.onClosePanel,
          onFormSubmit: _ctx.onSubmit,
          submitting: _ctx.state.submitting
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("input", {
                      type: "file",
                      id: "file-type",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                    }, null, 32)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onFormDiscard", "onFormSubmit", "submitting"])
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ], 64))
}